import React from 'react'

export default () => (
    <div className="invite-tips">
        <div className="invite-tips-title">
            <div className="invite-tips__header">
                <span className="invite-accepted-header__line"/>
                <span className="invite-accepted-header__text">活动细则</span>
                <span className="invite-accepted-header__line"/>
            </div>
        </div>
        <div className="invite-tips-content">
            <p>1. 分享当前页给新用户，新用户点击领取并下载APP，即可获得一节畅销书解读课，课程可以永久回听</p>
            <p>2. 新用户指未使用第三方账号登录过APP的用户</p>
            <p>3. 你推荐的新用户只要登录APP成功领取课程，您即获得畅销书解读课</p>
            <p>4. 每人最多可领3节课，领完即止</p>
            <p>5. 荔课对该活动保持最终解释权</p>
        </div>
    </div>
)



// WEBPACK FOOTER //
// ./src/pages/AppPage/InviteNewUser/InviteTips.js